import EntryRow from "./EntryRow.jsx";
import "../../styles/visualization/listView.css";

const ListView = ({
  entries = [],
  hoveredIndex,
  setHoveredIndex,
  currentFolderPath,
}) => {
  return (
    <div className="folder-list-view">
      {entries.map((entry, idx) => (
        <EntryRow
          key={entry.itemId}
          entry={entry}
          index={idx + 1}
          hovered={hoveredIndex === idx}
          onHover={() => setHoveredIndex(idx)}
          onLeave={() => setHoveredIndex(null)}
          currentFolderPath={currentFolderPath}
        />
      ))}
    </div>
  );
};

export default ListView;
